// Returns the number of whole days from now until the given ISO date string.
// Returns a negative number if the date is in the past.
export function daysUntil(isoDate) {
  // Append T12:00:00 so date-only strings parse as local noon, not UTC midnight.
  // Without this, Central Time devices (UTC-5/6) would parse '2026-08-12' as
  // Aug 11 locally and show the wrong day count.
  const target = new Date(isoDate + 'T12:00:00');
  const now = new Date();
  target.setHours(0, 0, 0, 0);
  now.setHours(0, 0, 0, 0);
  return Math.round((target - now) / (1000 * 60 * 60 * 24));
}

// Format an ISO date string for display.
// format: 'long'   → "Wednesday, August 12, 2026"
//         'medium' → "Aug 12, 2026"
//         'short'  → "8/12/2026"
//         'month'  → "August 2026"
export function formatDate(isoDate, format = 'medium') {
  if (!isoDate) return 'TBA';
  const date = new Date(isoDate + 'T12:00:00'); // noon to avoid DST edge cases
  const options = {
    long:   { weekday: 'long',  year: 'numeric', month: 'long',  day: 'numeric' },
    medium: {                   year: 'numeric', month: 'short', day: 'numeric' },
    short:  {                   year: 'numeric', month: 'numeric', day: 'numeric' },
    month:  {                   year: 'numeric', month: 'long' },
  };
  return date.toLocaleDateString('en-US', options[format] ?? options.medium);
}
